import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { SeleccionService } from '../../servicios/seleccion.service';
import { LoaderComponent } from '../../servicios/loader/loader.component';

@Component({
  selector: 'app-simulador-admin-ar',
  templateUrl: './simulador-admin-ar.component.html',
  styleUrls: ['./simulador-admin-ar.component.css']
})
export class SimuladorAdminARComponent implements OnInit {

  public mr: NgbModalRef;
  public vecEstudiante = []; public vecInfoEst = []; public vecMatObligatorias = []; public vecPeriodo = []; public vecMatAprueba = []; public vecObserva = [];
  public encabezado: string = ""; public nombreBeca: string = ""; public criterioBusca: string = ''; private selectPeriodo: string = '';
  public perEvaluado: string = ''; public promGeneral: number; private contNotas: number = 0;
  public buscar: string = '';

  constructor(private modalService: NgbModal, private alerti: AlertifyService, private srvSelect: SeleccionService, private cargando: LoaderComponent) { }

  ngOnInit() {
    this.instanciaVariables(); this.cargarPeriodos();
    this.encabezado = "Consideraciones para una postulación";
    this.nombreBeca = localStorage.getItem('modNom');
  }

  //FUNCION QUE CARGA TODAS LAS FACULTADES DE LA INSTITUCION
  async cargarPeriodos() {
    this.vecPeriodo = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(3, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.selectPeriodo = res.carrera[1]['strCodigo'];
      this.perEvaluado = res.carrera[1]['strDescripcion'];
      for (let objPer of res.carrera) {
        this.vecPeriodo.push({
          codigo: objPer.strCodigo, descripcion: objPer.strDescripcion, inicio: objPer.dtFechaInic, fin: objPer.dtFechaFin
        });
      }
    }
  }
  //FUNCION PARA ABRIR EL MODAL QUE PERMITE BUSCAR UN ESTUDIANTE
  bucarEstudiante(nameMod) {
    if (localStorage.getItem('modUser') == 'true') {
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //CRITERIO DE VARIAS OPCIONES DE BUESQUEDA DE UN ESTUDIANTE
  async criterioBuscarEstudiante() {
    this.vecInfoEst = [];
    const resEstudiantes = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(9, this.criterioBusca, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resEstudiantes.success) {
      this.vecInfoEst = resEstudiantes.carrera;
    }
    else
      this.alerti.error('No se encontraron resultados');
  }
  //BUSCAMOS LA MATRICULA DEL ESTUDIANTE
  async buscarEstudiante(datoEst) {
    this.buscar = datoEst.strCedula.replace('-', '');
    localStorage.setItem('buscarConsulta', datoEst.strCedula.replace('-', ''));
    let i = 0; let ban = 0; var codPerriodo = '';
    this.instanciaVariables();

    this.cargando.abrir();
    this.cerrarModal();
    if (this.buscar) {
      const resMatrCarrera = await new Promise<any>(resolve =>
        this.srvSelect.gestionMatricula(1, 'na', this.buscar, 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resMatrCarrera.success) {
        while (i < resMatrCarrera.matricula.length && ban == 0) {
          const res = await new Promise<any>(resolve =>
            this.srvSelect.gestionMatricula(33, resMatrCarrera.matricula[i]['baseCarrera'], this.buscar, this.selectPeriodo, 'na').subscribe(translated => {
              resolve(translated)
            }));

          if (res.success) {
            this.obtenerDatosCentralizada(this.buscar, resMatrCarrera.matricula[i]['nombFacultad'], resMatrCarrera.matricula[i]['nombCarrera'], res.matricula[0]['strCodNivel'],
              resMatrCarrera.matricula[i]['baseCarrera'], res.matricula[0]['strCodPeriodo']);
            //this.verHistoria(this.buscar);
            ban = 1;
            this.vecEstudiante[0]['tipoEst'] = 'Estudiante'; this.vecEstudiante[0]['baseCarrera'] = resMatrCarrera.matricula[i]['baseCarrera'];
            this.verMateriasObligatorias(resMatrCarrera.matricula[i]['baseCarrera'], res.matricula[0]['strCodNivel'], res.matricula[0]['strCodPensum'], res.matricula[0]['strCodEstud']);
          }
          i++;
        }
        if (ban == 0) {
          i = 0; ban = 0;
          while (i < resMatrCarrera.matricula.length && ban == 0) {
            const resEgreso = await new Promise<any>(resolve =>
              this.srvSelect.gestionMatricula(31, resMatrCarrera.matricula[i]['baseCarrera'], this.buscar, 'na', 'na').subscribe(translated => {
                resolve(translated)
              }));
            if (resEgreso.success) {
              this.obtenerDatosCentralizada(this.buscar, resMatrCarrera.matricula[i]['nombFacultad'], resMatrCarrera.matricula[i]['nombCarrera'], 'E',
                resMatrCarrera.matricula[i]['baseCarrera'], codPerriodo);
              //this.verHistoria(this.buscar);
              ban = 1;
              this.vecEstudiante[0]['tipoEst'] = 'Egresado';

              const resTitula = await new Promise<any>(resolve =>
                this.srvSelect.gestionMatricula(32, resMatrCarrera.matricula[i]['baseCarrera'], resEgreso.matricula[0]['intCodigo'], 'na', 'na').subscribe(translated => {
                  resolve(translated)
                }));
              if (resTitula.success) {
                this.alerti.error('El estudiante ya se encuentra titulado');
                ban = 2;
                this.vecEstudiante[0]['tipoEst'] = 'Titulado';
              }
            }
            i++;
          }
        }
      }
      if (ban == 0) {
        this.alerti.error('No se encontró matricula vigente del estudiante.');
        //this.opAddCita = false;
        this.obtenerDatosCentralizada(this.buscar, resMatrCarrera.matricula[0]['nombFacultad'], resMatrCarrera.matricula[0]['nombCarrera'], 'ND',
          resMatrCarrera.matricula[0]['baseCarrera'], 'Cerrado'); //this.verHistoria(this.buscar);
        ban = 1;
        this.vecEstudiante[0]['tipoEst'] = 'Sin Matrícula';
      }
      //this.datosFicha();
    }
    else
      this.alerti.error('Debe ingresar el número de cédula del estudiante.');
    this.cargando.cerrar();
  }
  //OBTENER LOS DATOS DEL ESTUDIANTE DE LA CENTRALIZADA
  obtenerDatosCentralizada(buscar, facultad, carrera, nivel, baseCarrera, periodo) {
    this.srvSelect.personaCentralDocumento(buscar).subscribe(data => {
      if (data.success) {
        this.vecEstudiante[0]['estudiante'] = data.datos['per_nombres'] + ' ' + data.datos['per_primerApellido'] + ' ' + data.datos['per_segundoApellido'];
        this.vecEstudiante[0]['correo'] = data.datos['per_email'];
        this.vecEstudiante[0]['nombFacultad'] = facultad;
        this.vecEstudiante[0]['nombCarrera'] = carrera;
        this.vecEstudiante[0]['codNivel'] = nivel;
        this.vecEstudiante[0]['carrera'] = baseCarrera;
        this.vecEstudiante[0]['periodo'] = periodo;
      } else {
        this.alerti.error('No se encontró al estudiante.');
      }
    });
  }
  //MATERIAS OBLIGATORIAS DICTADAS EN UNA CARRERA Y SEMESTRE
  async verMateriasObligatorias(baseCarrera, nivel, pensum, estudiante) {
    const resOblig = await new Promise<any>(resolve =>
      this.srvSelect.gestionMatricula(12, baseCarrera, nivel, pensum, 'na').subscribe(translated => {
        resolve(translated)
      }));

    if (resOblig.success)
      this.vecMatObligatorias = resOblig.matricula;
    for (let contMat of this.vecMatObligatorias) {
      await this.verMateriasAprobadas(baseCarrera, estudiante, contMat.codMateria);
    }
    this.promGeneral = this.promGeneral / this.contNotas;
    this.vecObserva[0]['numMaterias'] = resOblig.matricula.length; this.vecObserva[0]['numAprueba'] = this.contNotas;

    if ((this.vecObserva[0]['numMaterias'] == this.vecObserva[0]['numAprueba']) && (this.vecObserva[0]['numSuspenso'] == 0) && (this.vecObserva[0]['numConvalida'] == 0)
      && (this.vecObserva[0]['numPierde'] == 0))
      this.vecObserva[0]['detalle'] = 'El estudiante cumple con los requisitos establecidos para este tipo de becas';
    else
      this.vecObserva[0]['detalle'] = 'El estudiante NO cumple con los requisitos establecidos para este tipo de becas';
  }
  //VER EL MODO DE APROVACION DE MATERIAS DEL ESTUDIANTE
  async verMateriasAprobadas(baseCarrera, estudiante, materia) {
    const resConvalida = await new Promise<any>(resolve =>
      this.srvSelect.gestionMatricula(10, baseCarrera, estudiante, materia, 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resConvalida.success) {
      this.vecObserva[0]['numConvalida'] += 1;
      this.vecMatAprueba.push({
        codMateria: resConvalida.matricula[0]['strCodMateria'], nombMateria: resConvalida.matricula[0]['strNombre'], acumula: resConvalida.matricula[0]['bytNota'], nota: '',
        equivale: 'Convalida', promedio: resConvalida.matricula[0]['bytNota'], periodo: resConvalida.matricula[0]['dtFechaAprob'].split('T')[0], estilo: 'tdReprueba'
      });
    }
    else {
      const resAprueba = await new Promise<any>(resolve =>
        this.srvSelect.gestionMatricula(15, baseCarrera, estudiante, materia, 'na').subscribe(translated => {
          resolve(translated)
        }));

      if (resAprueba.success) {
        for (let objApr of resAprueba.matricula) {
          if (objApr.strCodEquiv != 'S') {
            this.promGeneral += (objApr.bytAcumulado + objApr.bytNota) / 2; this.contNotas++;
          }
          this.vecMatAprueba.push({
            codMateria: objApr.strCodMateria, nombMateria: objApr.strNombre, acumula: objApr.bytAcumulado, nota: objApr.bytNota,
            equivale: objApr.strCodEquiv == 'E' ? 'Exonera' : objApr.strCodEquiv == 'A' ? 'Aprueba' : objApr.strCodEquiv == 'R' ? 'Reprueba' : 'Suspensión',
            promedio: (objApr.bytAcumulado + objApr.bytNota) / 2, periodo: objApr.strDescripcion, estilo: objApr.strCodEquiv == 'S' ? 'tdReprueba' : 'tdAprueba'
          });
          if (objApr.strCodEquiv == 'S')
            this.vecObserva[0]['numSuspenso'] += 1;
          if (objApr.strCodEquiv == 'R')
            this.vecObserva[0]['numPierde'] += 1;
        }
      }
    }
  }
  //INTANCIAMOS LA VARIABLES DEL SISTEMA
  instanciaVariables() {
    this.vecEstudiante = []; this.vecMatAprueba = []; this.vecObserva = []; this.promGeneral = 0; this.contNotas = 0;
    this.vecEstudiante.push({ estudiante: '', correo: '', nombFacultad: '', nombCarrera: '', codNivel: '', carrera: '', baseCarrera: '', periodo: '', tipoEst: '', celular: '' });
    this.vecObserva.push({ numMaterias: 0, numAprueba: 0, numSuspenso: 0, numConvalida: 0, numPierde: 0, detalle: '', numPeriodo: '' });
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }

}
